import './styles/globals.css';
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import Login from "./pages/Login/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard/Dashboard";
import NotFound from "./pages/OtherPage/NotFound";
import UserProfiles from "./pages/UserProfiles";
import { UIProvider } from "./context/UI";
import CustomerPage from "./pages/customers/CustomerPage";
import UsersPage from "./pages/EMS/UserPage";
import AddUser from "./pages/EMS/AddUser";
import DepartmentPage from "./pages/EMS/DepartmentPage";
import AddDepartment from "./pages/EMS/AddDepartment";
import EditDepartment from "./pages/EMS/EditDepartment";
import ModulePage from "./pages/EMS/ModulePage";
import AddModule from "./pages/EMS/AddModule";
import EditModule from "./pages/EMS/EditModule";
import SubDepartmentPage from "./pages/EMS/SubDepartmentPage";
import AddSubDepartment from "./pages/EMS/AddSubDepartment";
import EditSubDepartment from "./pages/EMS/EditSubDepartment";
import EditUser from "./pages/EMS/EditUser";
import WaitListPage from "./pages/waitlist/WaitListPage";
import CustomerDetails from "./pages/customers/CustomerDetails";
import StylistPage from "./pages/stylist/StylistPage";
import AddStylist from "./pages/stylist/AddStylist";
import StylistDetails from "./pages/stylist/StylistDetails";
import EditStylist from "./pages/stylist/EditStylist";
import EventsPage from "./pages/events/EventsPage";
import AddEvents from "./pages/events/AddEvent";
import EditEvents from "./pages/events/EditEvents";
import CategoryPage from "./pages/category/CategoryPage";
import EventsDetails from "./pages/events/EventsDetails";
import CategoryDetails from "./pages/category/CategoryDetails";
import AddCategory from "./pages/category/AddCategory";
import EditCategory from "./pages/category/EditCategory";
import VibesPage from "./pages/vibes/VibesPage";
import AddVibes from "./pages/vibes/AddVibes";
import EditVibes from "./pages/vibes/EditVibes";
import SubDepartmentDetails from "./pages/EMS/SubDeapartmentDetails";
import UserDetails from "./pages/EMS/UserDetails";
import DepartmentDetails from "./pages/EMS/DepartmentDetails";
import VibeDetails from "./pages/vibes/VibeDetails";
import LookGenPage from "./pages/lookgen";
import { ProtectedRoute } from "./utilities/helper";
import MerchantPage from "./pages/e-commerce/MerchantPage";
import CatalogPage from "./pages/catalog/CatalogPage";
import ProductDetails from "./pages/catalog/ProductDetails";
import InsiderDashboard from './pages/insiders/InsiderDashboard';
import InsiderDetails from './pages/insiders/InsiderDetails';
import LeadershipBoard from './pages/insiders/LeadershipBoard';
import NotificationPage from './pages/marketing/NotificationPage';
import TemplateDetails from './pages/marketing/TemplateDetails';
import AddTemplatePage from './pages/marketing/AddTemplatePage';
import EditTemplatePage from './pages/marketing/EditTemplatePage';
import TemplateHistoryPage from './pages/marketing/TemplateHistoryPage';
import CustomerTemplatePage from './pages/customers/CustomerTemplatePage';
import TemplateHistoryDetails from './pages/marketing/TemplateHistoryDetails';
import StylistTabs from './pages/stylist/StylistTabs';
import LookGeneration from './pages/lookgeneration/LookGeneration';
import LookGenerationDetails from './pages/lookgeneration/LookGenerationDetails';
import AiLookGeneration from './pages/lookgeneration/AiLookGeneration';
import LookGenerationResults from './pages/lookgeneration/LookGenerationResults';

import VendorProducts from './pages/e-commerce/VendorProducts';
import GeneratedLooks from './pages/generatedlooks/Generatedlooks';
import OutfitDetails from './pages/generatedlooks/OutfitDetails';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <UIProvider>
          <Routes>
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
            </Route>
            <Route element={<AppLayout />}>
              <Route index
                path="/"
                element={
                  <ProtectedRoute allowedRoles={[1, 4]}>
                    <Dashboard />
                  </ProtectedRoute>
                } />
              <Route
                path="/waitlist"
                element={
                  <ProtectedRoute allowedRoles={[1, 4]}>
                    <WaitListPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <CustomerPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/customers-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <CustomerDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/template"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <CustomerTemplatePage />
                  </ProtectedRoute>
                } />

              {/* LOOK GENERATION */}

              <Route
                path="/look-generation/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <LookGeneration />
                  </ProtectedRoute>
                } />

              <Route
                path="/look-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <LookGenerationDetails />
                  </ProtectedRoute>
                } />

              <Route
                path="/look-generation-results"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <LookGenerationResults />
                  </ProtectedRoute>
                } />

              {/* STYLIST */}
              <Route
                path="/stylists"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <StylistTabs />
                  </ProtectedRoute>
                } />
              <Route
                path="/stylists-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <StylistDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-stylists"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <AddStylist />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-stylists/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <EditStylist />
                  </ProtectedRoute>
                } />

              {/* GENERATED LOOKS */}
              <Route
                path="/generated-looks"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <GeneratedLooks />
                  </ProtectedRoute>
                } />
              <Route
                path="/outfit-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <OutfitDetails />
                  </ProtectedRoute>
                } />

              {/* Events */}
              <Route
                path="/events"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <EventsPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/events-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <EventsDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-event"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <AddEvents />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-event/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <EditEvents />
                  </ProtectedRoute>
                } />

              {/* Category */}
              <Route
                path="/category"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <CategoryPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/category-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <CategoryDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-category"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <AddCategory />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-category/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <EditCategory />
                  </ProtectedRoute>
                } />

              {/* Vibe */}
              <Route
                path="/vibes"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <VibesPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/vibe-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <VibeDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-vibe"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <AddVibes />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-vibe/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <EditVibes />
                  </ProtectedRoute>
                } />

              {/* Look Generation */}
              <Route
                path="/lookgen"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <AiLookGeneration />
                    {/* <LookGenPage /> */}
                  </ProtectedRoute>
                } />

              {/* Catalog */}
              <Route
                path="/catalog"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <CatalogPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/product-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <ProductDetails />
                  </ProtectedRoute>
                } />


              <Route
                path="/e-commerce/vendor-products"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <VendorProducts />
                  </ProtectedRoute>
                } />

              {/* E-Commerce */}
              <Route
                path="/merchant"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <MerchantPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/product"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <CatalogPage />
                  </ProtectedRoute>
                } />

              {/* EMSS */}
              <Route
                path="/user"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <UsersPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/user-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <UserDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-user"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <AddUser />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-user/:id"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <EditUser />
                  </ProtectedRoute>
                } />
              <Route
                path="/department"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <DepartmentPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/department-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <DepartmentDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-department"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <AddDepartment />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-department/:id"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <EditDepartment />
                  </ProtectedRoute>
                } />
              <Route
                path="/modules"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <ModulePage />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-modules"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <AddModule />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-modules/:id"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <EditModule />
                  </ProtectedRoute>
                } />
              <Route
                path="/sub-department"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <SubDepartmentPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-subdepartment"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <AddSubDepartment />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-subdepartment/:id"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <EditSubDepartment />
                  </ProtectedRoute>
                } />
              <Route
                path="/subdepartment-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[4]}>
                    <SubDepartmentDetails />
                  </ProtectedRoute>
                } />

              {/* INSIDERS */}
              <Route
                path="/insider-dashboard"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <InsiderDashboard />
                  </ProtectedRoute>
                } />
              <Route
                path="/insider-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <InsiderDetails />
                  </ProtectedRoute>
                } />
              <Route
                path="/leader-board"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <LeadershipBoard />
                  </ProtectedRoute>
                } />

              {/* MARKETING || NOTIFICATION  */}

              <Route
                path="/notification"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <NotificationPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/add-template"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <AddTemplatePage />
                  </ProtectedRoute>
                } />
              <Route
                path="/edit-template/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <EditTemplatePage />
                  </ProtectedRoute>
                } />
              <Route
                path="/template-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <TemplateDetails />
                  </ProtectedRoute>
                } />

              {/* Template History  */}
              <Route
                path="/history"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <TemplateHistoryPage />
                  </ProtectedRoute>
                } />
              <Route
                path="/template-history-details/:id"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <TemplateHistoryDetails />
                  </ProtectedRoute>
                } />

              <Route
                path="/profile"
                element={
                  <ProtectedRoute allowedRoles={[1]}>
                    <UserProfiles />
                  </ProtectedRoute>
                } />

            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </UIProvider>
      </AuthProvider>
    </Router>
  );
}
